<template>
  <div class="sky-hc-bulletin-board__item-wrapper">
    <h6 class="sky-hc-bulletin-board__item-title">组织分布情况</h6>
    <div id="pieChart" class="sky-hc-bulletin-board__pie"></div>
  </div>
</template>
<script>
import { getDecentralizedOrg } from '@/api/characteristicOrg'
import { getDefaultPieOptions } from '@/utils'

let echarts = require('echarts/lib/echarts')
export default {
  name: 'DecentralizedOrgChart',
  data() {
    return {
      pieChart: null
    }
  },
  mounted() {
    this.handleGetData()
  },
  methods: {
    initPieChart(data) {
      require('echarts/lib/chart/pie')
      require('echarts/lib/component/tooltip')
      require('echarts/lib/component/legend')
      if (!this.pieChart) {
        this.pieChart = echarts.init(document.getElementById('pieChart'))
      }

      let options = getDefaultPieOptions()
      options.legend = [
        {
          orient: 'vertical',
          left: 'right',
          right: 0
        }
      ]
      options.series.data = [
        {
          value: data.decentralizedOrgNum,
          name: '分散型组织',
          itemStyle: {
            color: '#38A4F5'
          }
        },
        {
          value: data.total - data.decentralizedOrgNum,
          name: '集中型组织',
          itemStyle: {
            color: '#EBEBEB'
          },
          emphasis: {
            itemStyle: {
              color: '#EBEBEB'
            }
          }
        }
      ]

      options && this.pieChart.setOption(options)
      this.addPieChartClick()
    },
    addPieChartClick() {
      const _this = this
      this.pieChart &&
        this.pieChart.on('click', function(params) {
          if (params.name === '分散型组织') {
            _this.$router.push({ name: 'decentralizedOrgList' })
          }
        })
    },
    handleGetData() {
      getDecentralizedOrg()
        .then(response => {
          const data = response.data.content
          console.log('data', data)
          this.initPieChart({
            total: data.orgCount,
            decentralizedOrgNum: data.featureOrgCount
          })
        })
        .catch(e => {
          console.log('e', e)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-bulletin-board) {
  @include e(pie) {
    width: 400px;
    height: 300px;
  }
}
</style>
